<template>
    <LayoutGradient :title="pageTitle" icon="fa-file-signature">
        <template v-slot:headerRight>
        <b-btn variant="outline-info" @click="$router.back()">
            <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>
        </template>
        <b-card class="m-3 mt-n10">
            <SimpleForm :fields="fields" :model="model" @submit="onSubmit">
                <template #submitButton>
                    <b-button variant="success" type="submit" >
                        <i class="fas fa-save"/> {{ $t('tipo.form.fields.botao_salvar') }}
                    </b-button>
                </template>
            </SimpleForm>
        </b-card>
    </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import TypeRepository from '@/repositories/dexpara/Type/TypeValueRepository';
import {mapActions, mapGetters} from "vuex";
import SimpleForm from "@/components/FormGenerator/SimpleForm";

export default {
    name: "Form",
    components: {LayoutGradient, SimpleForm},
    data() {
        return {
            tipo_id: null,
            value_id: null,
            fields: [
                {
                    label: this.$t('tipo.value.form.fields.codigo.label'),
                    name: 'code',
                    description: this.$t('tipo.value.form.fields.codigo.description'),
                },
                {
                    label: this.$t('tipo.value.form.fields.nome.label'),
                    name: 'name',
                    description: this.$t('tipo.value.form.fields.nome.description'),
                },
                {
                    label: this.$t('tipo.value.form.fields.description.label'),
                    name: 'description',
                    description: this.$t('tipo.value.form.fields.description.description'),
                },
                {
                    label: this.$t('tipo.value.form.fields.status.label'),
                    type: 'checkbox',
                    name: 'status',
                    description: this.$t('tipo.value.form.fields.status.description'),
                },
            ],
            model: {
                id: null,
                code: '',
                name: '',
                description: '',
                status: false,
            },
        }
    },
    computed: {
        ...mapGetters({
            value: 'type/value/current',
            isLoading: 'type/value/isLoading'
        }),
        pageTitle() {
            if (this.value_id) return this.$t('tipo.value.form.titulo_pagina.editar')
            return this.$t('tipo.value.form.titulo_pagina.criar')
        }
    },
    methods: {
        ...mapActions([
            'type/value/listOne'
        ]),
        async onSubmit(evt) {
            if (this.value_id) {
                this.update()
            } else {
                this.create()
            }
        },
        create() {
            TypeRepository.post({
                ...this.model,
                mapping_type_id: this.tipo_id
            }).then(() => {
                this.$snotify.success(this.$t('tipo.value.form.create.success'))
                this.$router.push({name: 'tipo'})
            }).catch(error => {
                this.$snotify.error(this.$t('tipo.value.form.create.error'))
                if (error.response.status === 422) {
                    TypeRepository.toastValidationErrors(error, this.$snotify)
                }
            })
        },
        update() {
            TypeRepository.put(this.value_id, this.model).then(() => {
                this.$snotify.success(this.$t('tipo.value.form.update.success'))
                this.$router.push({name: 'tipo'})
            }).catch(error => {
                this.$snotify.error(this.$t('tipo.value.form.update.error'))
                if (error.response.status === 422) {
                    TypeRepository.toastValidationErrors(error, this.$snotify)
                }
            })
        }
    },
    async mounted() {
        this.$store.commit('type/value/setCurrent', {status: false})
        this.tipo_id = this.$route.params.tipo_id
        if (this.$route.params.id) {
            this.value_id = this.$route.params.id
            await this['type/value/listOne'](this.$route.params.id)
            this.model = {
                ...this.model,
                ...this.value.data.typeValue,
                status: !!this.value.data.typeValue.status || false
            }
        }
    },
}
</script>
